exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vux-label-desc {\r\n  font-size:14px;\r\n  color:#666;\n}\r\n", "", {"version":3,"sources":["D:/git/qrt_m/node_modules/vux/src/components/inline-desc/index.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,WAAW;CACZ","file":"index.vue","sourcesContent":["\n.vux-label-desc {\r\n  font-size:14px;\r\n  color:#666;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d40071a","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vux/src/components/inline-desc/index.vue
// module id = V8Nl
// module chunks = 0